import React, { useState } from "react";
import Page from "../../Components/Page";
import {
  Box,
  Button,
  Card,
  CardContent,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import FetchHook from "../../Api/FetchHooks";
import { DatePicker } from "@mui/x-date-pickers";

const SasraSavingsReport = () => {
  const location = useLocation();
  const loggedInUser = useSelector((state) => state?.auth?.user);

  const [loading, response, request] = FetchHook();

  const [user, setUser] = useState(location?.state?.user || loggedInUser);
  const [data, setData] = useState([]);
  const [status, setStatus] = useState("all");
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  const [open, setOpen] = React.useState(false);
  const [dialog, setDialog] = useState({
    open: false,
    type: null,
    label: null,
  });
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "info",
  });

  const openDialog = (type, label) => setDialog({ open: true, type, label });
  const closeDialog = () => setDialog({ open: false, type: null, label: null });

  const handleSnackbarClose = () => {
    setSnackbar((prev) => ({ ...prev, open: false }));
  };
  return (
    <Page
      title={"Savings Report"}
      actions={
        <Grid
          item
          sx={{
            display: "flex",
            gap: "20px",
            alignItems: "center",
          }}
        >
          <DatePicker
            value={startDate}
            onChange={(newValue) => setStartDate(newValue)}
            renderInput={(params) => {
              return (
                <TextField
                  {...params}
                  onClick={(e) => setOpen(true)}
                  label="Start Date"
                />
              );
            }}
          />{" "}
          ----{" "}
          <DatePicker
            value={endDate}
            onChange={(newValue) => setEndDate(newValue)}
            renderInput={(params) => {
              return (
                <TextField
                  {...params}
                  onClick={(e) => setOpen(true)}
                  label="End Date"
                />
              );
            }}
          />
          <FormControl>
            <InputLabel id="status">Status</InputLabel>

            <Select
              labelId="loan_status"
              id="loan_status"
              value={status}
              label="status"
              onChange={(e) => {
                setStatus(e.target.value);
              }}
              size="small"
            >
              <MenuItem value="all">All</MenuItem>
              <MenuItem value="confirmed">Confirmed</MenuItem>
            </Select>
          </FormControl>
          {startDate !== undefined && endDate !== undefined && (
            <Button variant="contained" size="large">
              search
            </Button>
          )}
        </Grid>
      }
    >
      <Card>
        <CardContent> </CardContent>
      </Card>
    </Page>
  );
};

export default SasraSavingsReport;
